/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import {
  Descriptions, Empty, Popover, Table, Tooltip
} from 'antd';
import { InfoCircleTwoTone } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import allActions from '../../../../../actions';
import Loading from '../../../../../components/loading/Loading';
import { getSAPLinkFunction, getSAPLink } from '../../../components/helpers';
import './LeadTime.css';

function LeadTimeTab({
  loadingKey,
  materialLeadTime,
  materialLeadTimeInsight,
}) {
  const dispatch = useDispatch();
  const { plant, material } = useParams();
  const loading = useSelector((state) => state.materialDetailsState.loading);
  const { Item } = Descriptions;
  const [columns, setColumns] = useState();
  const [dataSource, setDataSource] = useState();
  const data = useSelector((state) => state.materialDetailsState.material);
  const plantData = data?.find(
    (rec) => rec.PLANT_FACILITY_SAP_ID === plant
      && rec.MATERIAL_TYPE_SAP_ID === material,
  );

  const getCorrectDate = (date) => {
    const dateAndTime = date.split('T');
    const dayMonthYear = dateAndTime[0].split('-');
    const hourMinute = dateAndTime[1].split(':');
    const string = `${dayMonthYear[2]}.${dayMonthYear[1]}.${dayMonthYear[0]}`;
    return string;
  };

  useEffect(() => {
    if (plant && material) {
      dispatch(allActions.MaterialDetailsActions.setLoading(loadingKey));
      dispatch(allActions.MaterialDetailsActions.fetchMaterialLeadTime(plant, material));
    }
  }, [dispatch, loadingKey, plant, material]);

  useEffect(() => {
    console.log(materialLeadTime, plantData);
    if (materialLeadTime?.length > 0 && plantData) {
      let ltSource = materialLeadTime[0]?.PO_LT_SOURCE;
      if (ltSource) {
        if (ltSource === 'Purchase order same cc') {
          ltSource = 'SAME_COMPANY_CODE';
        } else {
          ltSource = 'OTHER_COMPANY_CODE';
        }
        dispatch(allActions.MaterialDetailsActions.fetchMaterialLeadTimeInsight(
          plant, material, ltSource,
          ltSource === 'OTHER_COMPANY_CODE' ? null : plantData?.COMPANY_CODE
        ));
      }
    }
  }, [materialLeadTime, plantData]);

  useEffect(() => {
    const insightColumns = ['PO', 'GR Date', 'Lead Time', 'Plant'];
    const hasInsight = materialLeadTimeInsight?.length > 0;
    setColumns(hasInsight ? insightColumns : []);
    const getSortedList = hasInsight ? materialLeadTimeInsight.map((changeObject, index) => ({
      key: `${index}`,
      PO: getSAPLink('Navigate to ME2N in SAP', 'ME2N', [changeObject?.PURCHASE_ORDER, changeObject?.PLANT_FACILITY_SAP_ID], changeObject?.PURCHASE_ORDER),
      'GR Date': getCorrectDate(changeObject.GR_DATE),
      'Lead Time': changeObject.PO_LEAD_TIME,
      Plant: changeObject.PLANT_FACILITY_SAP_ID,
    })) : [];
    getSortedList.sort((a, b) => new Date(b['GR Date']) - new Date(a['GR Date']));
    setDataSource(getSortedList);
  }, [materialLeadTimeInsight]);

  const tableStyle = {
    fontSize: '12px',
    height: '5px',
    padding: '4px',
    width: '20ch',
  };

  const tableContent = (records) => {
    let tableLoading = true;
    if (records) {
      tableLoading = false;
    }
    return (
      <Table
        dataSource={dataSource}
        bordered
        columns={columns?.map((key) => ({ title: key, dataIndex: key, key }))}
        pagination={false}
        size="small"
        loading={tableLoading}
      />
    );
  };

  const getContractRow = (data) => {
    if (!data?.CONTRACT_ITEM_NUMBER) return '';

    let itemNo = data?.CONTRACT_ITEM_NUMBER || '';
    itemNo = Number.parseInt(itemNo, 10);
    const spName = data?.SUPPLIER_NAME || '';
    let spNo = data?.SUPPLIER_NUMBER || '';
    spNo = Number.parseInt(spNo, 10);
    let validTo = data?.VALID_TO || '';

    let finalString = ` Item ${itemNo} `;

    if (validTo && validTo !== '') {
      validTo = new Date(validTo);
      let dt = validTo?.getDate()?.toString();
      if (dt?.length === 1) {
        dt = `0${dt}`;
      }

      let month = validTo?.getMonth();
      if (month || month === 0) month += 1;
      month = month?.toString();
      if (month?.length === 1) {
        month = `0${month}`;
      }

      const year = validTo?.getFullYear()?.toString()?.slice(2, 4);
      validTo = `${dt}.${month}.${year}`;

      if (Number.isNaN(spNo)) {
        spNo = 'Not Available';
      } else {
        spNo = spNo?.toString();
      }

      if (validTo?.length < 5) validTo = 'Not Available';
      if (spNo?.includes('Not')) {
        finalString = `${finalString} (Vendor: ${spNo}, valid to: ${validTo})`;
      } else {
        finalString = `${finalString} (Vendor: ${spNo}, ${spName}, valid to: ${validTo})`;
      }
    }

    return (
      <>
        <span>
          {getSAPLink(
            'Click to navigate to ME33K in SAP',
            'ME33K',
            [data?.CONTRACT_NUMBER],
            data?.CONTRACT_NUMBER,
          )}
        </span>
        <span>{finalString}</span>
      </>
    );
  };

  return (
    <>
      {loading && loading[loadingKey]
        ? <Loading />
        : (!loading[loadingKey] && materialLeadTime && materialLeadTime[0]
          && materialLeadTime?.[0].PLANT_FACILITY_SAP_ID === plant
          && materialLeadTime?.[0].MATERIAL_TYPE_SAP_ID === material ? (
            <>
              <Descriptions
                className="leadTable"
                column={1}
                bordered
                labelStyle={tableStyle}
                contentStyle={tableStyle}
              >
                <Item style={{ fontWeight: 'bold' }} label="Contract">Days</Item>
                <Item label="LeadTime Source">{materialLeadTime[0]?.CONTRACT_LT_SOURCE}</Item>
                <Item label="LeadTime From Supplier">{materialLeadTime[0]?.CONTRACT_PLANNED_DELIVERY_TIME}</Item>
                <Item label="LeadTime From Supplier Incl Weekends">{materialLeadTime[0]?.CONTRACT_PLANNED_DELIVERY_TIME_ADJ}</Item>
                <Item label="Transport">{materialLeadTime[0]?.CONTRACT_VENDOR_LT}</Item>
                <Item label="PO Processing Time">{materialLeadTime[0]?.CONTRACT_PROCESSING_TIME}</Item>
                <Item label="Contract number">
                  {getContractRow(materialLeadTime[0])}
                </Item>
                <Item label="Total Contract LeadTime">{materialLeadTime[0]?.CONTRACT_LEAD_TIME}</Item>
              </Descriptions>
              <Descriptions
                column={1}
                bordered
                labelStyle={tableStyle}
                contentStyle={tableStyle}
                className="leadTable"
              >
                <Item label="Purchase Order" style={{ fontWeight: 'bold' }}>Days</Item>
                <Item label="LeadTime Source">{materialLeadTime[0]?.PO_LT_SOURCE}</Item>
                <Item label="LeadTime From Supplier">
                  <span>{materialLeadTime[0]?.PO_LEAD_TIME_SUPPLIER}</span>
                  {materialLeadTime[0]?.PO_LEAD_TIME_SUPPLIER > 0 ? (
                    <Popover
                      trigger="click"
                      title="Avg. 'LeadTime From Supplier', based on:"
                      content={tableContent(materialLeadTimeInsight)}
                    >
                      <Tooltip title="More info">
                        <InfoCircleTwoTone style={{ textAlign: 'center', marginLeft: '3px' }} />
                      </Tooltip>
                    </Popover>
                  ) : null}
                </Item>
                <Item label="PO Processing Time">{materialLeadTime[0]?.PO_PROCESSING_TIME}</Item>
                <Item label="Total PO LeadTime">{materialLeadTime[0]?.PO_LEAD_TIME}</Item>
              </Descriptions>
              <Descriptions
                column={1}
                bordered
                labelStyle={tableStyle}
                className="leadTable"
                contentStyle={tableStyle}
              >
                <Item label="Material Master" style={{ fontWeight: 'bold' }}>Days</Item>
                <Item label="MM LeadTime">{materialLeadTime[0]?.MM_LEAD_TIME}</Item>
                <Item label="PO Processing Time">{materialLeadTime[0]?.CC_MM_PROCESS_TIME}</Item>
                <Item label="Total MM LeadTime">{materialLeadTime[0]?.LT6_LEAD_TIME}</Item>
              </Descriptions>
              <Descriptions
                column={1}
                bordered
                labelStyle={tableStyle}
                className="leadTable"
                contentStyle={tableStyle}
              >
                <Item
                  style={{ fontWeight: 'bold' }}
                  label="GR processing time (not part of lead time calculation)"
                >
                  {materialLeadTime[0]?.GR_PROCESS_TIME}
                </Item>
              </Descriptions>
            </>
          ) : <Empty />)}
    </>
  );
}

export default LeadTimeTab;

LeadTimeTab.propTypes = {
  loadingKey: PropTypes.string.isRequired,
};
